import { createAction } from 'redux-actions'

export const onSnapshotTaking = createAction<void>('ON_SNAPSHOT_TAKING')

export const onSnapshotRequestReceived = createAction<
  [
    {
      attributes: {
        targetUserId: string
      }
    }
  ]
>('ON_SNAPSHOT_REQUEST_RECEIVED')

export const onSnapshotCreated = createAction<void>('ON_SNAPSHOT_CREATED')
export const onSnapshotProgressStateUpdate = createAction<boolean>('ON_SNAPSHOT_PROGRESS_STATE_UPDATE')
